<div class="bg-th-yellow mt-0 container-fluid" >

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> تنظیمات امنیتی سامانه </span>

    </div>

</div>

<main class="p-2">

    <div [formGroup]="pw_OptionsModel" class="row gx-2 gy-3 border border-2 rounded p-4">

        <h4 class="">تنظیمات امنیتی سامانه</h4>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="min_length"> حداقل طول رمز : </label>
            
            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
            
                formControlName="tiMinPasswordLength" type="text" id="min_length"  class="form-control" />
            
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="max_validity"> حداکثر زمان اعتبار کاربری(روز) : </label>
            
            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" formControlName="tiUserValidityPeriod"
                
                type="text" id="max_validity"  class="form-control" />
            
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="sessionTimeout"> مدت زمان نشست سامانه : </label>
            
            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" formControlName="iSessionTimeout"
                
                type="text" id="sessionTimeout"  class="form-control" />
            
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="wrongLogin"> تعداد مجاز ورود کاربری اشتباه : </label>
            
            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" formControlName="tiMaxWrongLogin"
                
                type="text" id="wrongLogin"  class="form-control" />
            
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="captcha_length"> طول کپچا : </label>
            
            <input dir="ltr" oninput="this.value = this.value.replace(/[^0-9.]/g, '')" formControlName="tiCaptchaLength"    
            
                type="text" id="captcha_length"  class="form-control" />
            
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="special_char"> رمز عبور شامل کاراکتر ویژه باشد  </label>

            <input type="checkbox" id="special_char" class="pointer" formControlName="bHasSpecialCharacter" />
                        
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="num_char"> رمز عبور شامل حرف و عدد باشد  </label>

            <input type="checkbox" id="num_char" class="pointer" formControlName="bLettersAndNumbers" />
                        
        </div>

        <div class="col-12 border border-2 p-2">

            <label class="pointer" for="captal_char"> رمز عبور شامل  حرف بزرگ در ابتدا باشد  </label>

            <input type="checkbox" id="captal_char" class="pointer" formControlName="bHasCapitalLetter" />
                        
        </div>

        <div class="col-12">

            <button class="btn btn-primary px-5" (click)="pwOptions_Update()"> ویرایش </button>

        </div>

    </div>

</main>